// ─────────────────────────────────────────────
//  PeoplePicker.jsx
//  Contador de personas para dividir la cuenta
//
//  RN migration:
//  • <div> → <View>, <span> → <Text>
//  • <button> → <TouchableOpacity>
// ─────────────────────────────────────────────

import React from 'react';
import styles from './PeoplePicker.module.css';

export default function PeoplePicker({ people, onChange }) {
	return (
	
		<section className={styles.card2} aria-label="Número de personas">
		{/* <p className={styles.label}>Dividir entre</p> */}

			<div className={styles.row}>
				<p className={styles.label}>Nº personas</p>

				<div
					className={styles.counter}
					role="group"
					aria-label="Contador de personas"
				>
					<button
						className={styles.counterBtn}
						onClick={() => onChange(-1)}
						aria-label="Reducir una persona"
						disabled={people <= 1}
					>
						−
					</button>
					<span
						className={styles.counterValue}
						aria-live="polite"
						aria-atomic="true"
					>
						{people}
					</span>
					<button
						className={styles.counterBtn}
						onClick={() => onChange(1)}
						aria-label="Agregar una persona"
						disabled={people >= 20}
					>
						+
					</button>
				</div>

			</div>
		</section>
	);
}

